export class CloneName {
  static readonly type = '[Contract.Name] Clone Name';
  constructor(public nameID: number, public copies: number = 1) {}
}

export class DeleteName {
  static readonly type = '[Contract.Name] Delete Name';
  constructor(public nameID: number) {}
}

export class RestoreName {
  static readonly type = '[Contract.Name] Restore Name';
  constructor(public nameID: number) {}
}

export class AddName {
  static readonly type = '[Contract.Name] Add Name';
  constructor(public Name: any) {}
}

export class UpdateName {
  static readonly type = '[Contract.Name] Update Name';
  constructor(public Name: any) {}
}
